<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400">
      <div class="logo">
        <!-- <img
          :src="require('@/page/estimulocrédito/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">Conficreo, S.A.P.I. de C.V., SOFOM, E.N.R.</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Home</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li2">
          <router-link to="/about" class="nav-link2">
            <span class="routeText2">About Us</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/process' }" class="Li3">
          <router-link to="/process" class="nav-link3">
            <span class="routeText3">Loan Process</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/help' }" class="Li4">
          <router-link to="/help" class="nav-link4">
            <span class="routeText4">Help Center</span>
          </router-link>
        </li>
        <li
          :class="{ 'active-link': $route.path === '/condition' }"
          class="Li5"
        >
          <router-link to="/condition" class="nav-link5">
            <span class="routeText5">Terms and Conditions</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li6">
          <router-link to="/protocol" class="nav-link6">
            <span class="routeText6">Privacy Policy</span>
          </router-link>
        </li>
        <!-- <li class="Li7">
          <a href="https://mseaw.estimucredito.com/help/privacy_policy" class="nav-link6">
            <span class="routeText7">Privacy Policy(GooglePlay)</span></a
          >
        </li> -->
        <!-- <li
          :class="{
            'active-link': ['/questions', '/protocol'].includes($route.path),
          }"
          class="Li4"
        >
          <router-link to="/questions" class="nav-link4">
            <span class="routeText4">Vấn đề Thường Gặp</span>
          </router-link>
        </li> -->
        <!-- <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li5">
          <router-link to="/protocol" class="nav-link5">
            <span class="routeText5">Acuerdo de privacidad</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div style="height: 130px"></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 130px;
  padding: 0 30px;
  background-color: #ffffff;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
}

.title {
  width: 500px;
  height: 24px;
  font-size: 17px;
  font-family: SF Pro-Black Italic;
  font-weight: 600;
  color: #4F4F4F;
  line-height: 23px;
  padding-left: 17px;
  /* text-transform: uppercase; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5,
.routeText6,
.routeText7 {
  font-size: 14px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #9d9d9d;
  line-height: 29px;
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5,
.nav-link6,
.nav-link7 {
  text-decoration: none;
  margin: 0 auto;
  text-align: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  padding: 8px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  padding-left: 4px;
  padding-right: 4px;
}
.Li1 {
  width: 60px;
}
.Li2 {
  width: 90px;
}
.Li3 {
  width: 110px;
}
.Li4 {
  width: 110px;
}
.Li5 {
  width: 170px;
}
.Li6 {
  width: 190px;
}
.Li7 {
  width: 200px;
}
/* .Li5 {
  width: 250px;
} */
/* 这个如果给margin-right底部可能会出现边距的问题 */
/* .Li4 {
  width: 250px;
  
} */

.active-link {
  /* background: linear-gradient(45deg, #F59120, #F95C40); */
  background-color: #ca3e3d;
  /* border-color: #dae633; */
  border-radius: 20px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5,
.active-link .routeText6,
.active-link .routeText7 {
  color: #ffffff;
}
</style>